export default "__VITE_ASSET__BQlnI_Ib__"